<!-- Copyright (c) 201 Cigent Technology Inc. All Rights Reserved. -->

<div appLifecycleTracker
     trackerName="secure-ssd"
     class="scroll-area"
     infiniteScroll
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="50"
     (scrolled)="onScrollHandler()"
     [scrollWindow]="false">

    <div *ngIf="diskDataLoaded">
        <span class="endpoints-data-loaded"></span>
    </div>

    <div class="stats-container">
        <mat-card appearance="raised" class="clickable" (click)="filterOnNothing()">
            <mat-card-content>
                <div *ngIf="drivesLoaded$ | async; else loadingTotalNumber;" class="total-number">{{dashboardInfo.total}}</div>
                <ng-template #loadingTotalNumber>
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                        display: 'inline-flex',
                        height: '38px',
                        width: '50px',
                        margin: '8px 0 5px 0',
                      }">
                  </ngx-skeleton-loader>
                </ng-template>
                <div>{{fTotalSsds}}</div>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="raised" class="clickable" (click)="filterOnRemovable(false)">
            <mat-card-content>
                <div class="total-number">
                    <span *ngIf="drivesLoaded$ | async; else loadingInternal;">
                        <span>{{dashboardInfo.internal}}</span>
                        <span class="mdi mdi-harddisk" aria-hidden="true"></span>
                    </span>
                    <ng-template #loadingInternal>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="{
                              display: 'inline-block',
                              height: '38px',
                              width: '50px',
                              margin: '0 2px -3px 0',
                            }">
                        </ngx-skeleton-loader>
                        <span class="mdi mdi-harddisk" aria-hidden="true"></span>
                    </ng-template>
                </div>
                <div>
                    <div>{{fInternal}}</div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="raised" class="clickable" (click)="filterOnRemovable(true)">
            <mat-card-content>
                <div class="total-number">
                    <span *ngIf="drivesLoaded$ | async; else loadingExternal;">
                        <span>{{dashboardInfo.external}}</span>
                        <span class="mdi mdi-usb mdi-rotate-90" aria-hidden="true"></span>
                    </span>
                    <ng-template #loadingExternal>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="{
                              display: 'inline-block',
                              height: '38px',
                              width: '50px',
                              margin: '0 2px -3px 0',
                            }">
                        </ngx-skeleton-loader>
                        <span class="mdi mdi-usb mdi-rotate-90" aria-hidden="true"></span>
                    </ng-template>
                </div>
                <div>
                    <div class="footer-link-wrapper">{{fExternal}}</div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="raised" class="clickable" (click)="filterOnSeenInLast7Days()">
            <mat-card-content>
                <div *ngIf="drivesLoaded$ | async; else loadingLastSeen;" class="total-number">{{dashboardInfo.seen}}</div>
                <ng-template #loadingLastSeen>
                  <ngx-skeleton-loader
                    count="1"
                    appearance="line"
                    [theme]="{
                        display: 'inline-flex',
                        height: '38px',
                        width: '50px',
                        margin: '8px 0 5px 0',
                      }">
                  </ngx-skeleton-loader>
                </ng-template>
                <div>{{fLastSeenWidget}}</div>
            </mat-card-content>
        </mat-card>
    </div>

    <div *ngIf="(drivesLoaded$ | async); else loadCharSkeleton;" class="model-chart-container">
        <ngx-charts-bar-horizontal-stacked
                *ngIf="drives.length > 0; else noChartData"
                [results]="modelChartInfo"
                [scheme]="colorScheme"
                yAxis="true"
                xAxis="true"
                maxYAxisTickLength="40"
                legend="true"
                [xAxisTickFormatting]="modelChartXAxisFormat"
                [style]="modelChartStyle"
                customColors=""
                showDataLabel="true"
                gradient="true"
                (select)="filterOnChart($event)">
        </ngx-charts-bar-horizontal-stacked>
        <ng-template #noChartData><div class="no-drives-found">{{'NO_DRIVES_FOUND' | translate}}</div></ng-template>
    </div>
    <ng-template #loadCharSkeleton>
      <div class="model-chart-container skeleton-chart">
        <ngx-charts-bar-horizontal-stacked
                [results]="skeletonData"
                [scheme]="colorScheme"
                yAxis="true"
                xAxis="true"
                maxYAxisTickLength="40"
                legend="true"
                [xAxisTickFormatting]="modelChartXAxisFormat"
                [style]="modelChartStyle"
                customColors=""
                showDataLabel="true"
                gradient="true">
        </ngx-charts-bar-horizontal-stacked>
      </div>
    </ng-template>

    <div *ngIf="showProvisioningButtons" class="provision-actions-wrapper">
      <button id="button-provision" class="provision-button" mat-flat-button color="primary" (click)="onProvision()"
              [disabled]="!drivesSelected" type="button">
        {{'secure-ssd.provision-button-text' | translate}}
      </button>
      <button [disabled]="(drivesLoaded$ | async) === false || (isMSP$ | async)" class="more-actions-button" mat-flat-button color="primary" [matMenuTriggerFor]="menu"
              aria-label="More Actions Menu">
        <span class="mdi mdi-dots-horizontal"></span>
      </button>
      <mat-menu #menu xPosition="before">
        <button mat-menu-item (click)="onEditTemplate()">
          <span class="mdi mdi-square-edit-outline menu-icon"></span>
          <span>{{'secure-ssd.provision-menu.edit-template-text' | translate}}</span>
        </button>
        <button mat-menu-item (click)="onCancelProvision()" [disabled]="!pendingDrivesSelected">
          <span class="mdi mdi-cancel menu-icon"></span>
          <span>{{'secure-ssd.provision-menu.cancel-provision-text' | translate}}</span>
        </button>
      </mat-menu>
    </div>
    <div class="table-panel" id="drives-table-panel">
        <div class="table-controls">
            <div *ngIf="totalResults !== null && totalResults !== undefined" id="totalDrives" class="drive-total">
                <span class="footnote">{{fDrivesInfo}}</span>
            </div>
            <mat-chip-listbox class="chip-list">
                <ng-container *ngFor="let f of filterValues">
                  <mat-chip-option *ngIf="f[1] !== undefined">
                      <span>{{f[1]}}</span>
                      <button matChipRemove (click)="removeFilter(f[0])">
                          <span class="mdi mdi-close-circle"></span>
                      </button>
                  </mat-chip-option>
                </ng-container>
            </mat-chip-listbox>
            <mat-form-field class="filter-by-selection" appearance="outline">
              <mat-label>Filter by Last Seen</mat-label>
              <mat-select [value]="lastSeenFilter" aria-label="Select Last seen filter"
                          [disableOptionCentering]="true" (selectionChange)="onLastSeenSelectChanged($event.value)">
                  <mat-option [value]="LastSeenFilter.ALL_SUBSCRIPTIONS">Show All</mat-option>
                  <mat-option [value]="LastSeenFilter.CONNECTED">{{'D3ED_CONNECTED' | translate}}</mat-option>
                  <mat-option [value]="LastSeenFilter.WITHIN_7_DAYS">Last seen < 7 Days</mat-option>
                  <mat-option [value]="LastSeenFilter.WITHIN_1_MONTH">Last seen < 1 Month</mat-option>
                  <mat-option [value]="LastSeenFilter.WITHIN_3_MONTHS">Last seen < 3 Months</mat-option>
                  <mat-option [value]="LastSeenFilter.WITHIN_6_MONTHS">Last seen < 6 Months</mat-option>
              </mat-select>
            </mat-form-field>

            <app-column-chooser saveId="ssds" [elements]="columns"
                                (change)="updateDisplayedColumns($event)"></app-column-chooser>
        </div>
        <div class="tableDiv" id="drivestable">
            <table class="table" mat-table [dataSource]="drives" matSort matSortDisableClear='true'
                   matSortActive="lastSeen" matSortStart="desc" matSortDirection="desc"
                   (matSortChange)="sortColumn($event)" aria-describedby="List of secure drives">

                <ng-container *ngIf="showProvisioningButtons" matColumnDef="checkbox">
                    <th scope="col" mat-header-cell *matHeaderCellDef>
                        <mat-checkbox [(ngModel)]="selectAllChecked" (click)="selectAll()" [disabled]="isMSP$ | async"
                          aria-label="select/deselect all">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let drive">
                        <mat-checkbox [(ngModel)]="drive.checked" *ngIf="drive.driveInfo.configurable;"
                          (click)="checkSelectAllLater()" aria-label="select drive" [disabled]="isMSP$ | async">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="serial">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fDrivesSerial}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="serial">{{drive.driveInfo.serial}}</td>
                </ng-container>
                <ng-container matColumnDef="drive_partner">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{'ssd.disk_config.drive_partner' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="drive_partner">{{drive.driveInfo.drive_partner}}</td>
                </ng-container>
                <ng-container matColumnDef="model">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fDrivesModel}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="model">{{drive.driveInfo.model}}</td>
                </ng-container>+
                <ng-container matColumnDef="capacity">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fDrivesCapacity}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="capacity">{{drive.driveInfo | diskSize }}</td>
                </ng-container>
                <ng-container matColumnDef="version">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'VERSION' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="version">{{drive.driveInfo.license_version}}</td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fDrivesState}}
                    </th>
                      <td mat-cell *matCellDef="let drive" id="state">
                        <span *ngIf="drive.driveInfo.stateDisplay === 'Unconfigured' && drive.driveInfo.has_disk_defaults; else pendingProvision;">
                          {{provisionPendingStateLabel}}
                        </span>
                        <ng-template #pendingProvision>
                          <span>{{drive.driveInfo.stateDisplay}}</span>
                        </ng-template>
                      </td>
                </ng-container>
                <ng-container matColumnDef="opal_state">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPAL_STATE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="opal_state">{{drive.driveInfo.opal_state_display}}</td>
                </ng-container>
                <ng-container matColumnDef="disk_config_state">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ssd.disk_config.key' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="disk_config_key" >
                        <span *ngIf="drive.driveInfo.disk_config_state > 0 && (drive.driveInfo.configured === 1 || drive.driveInfo.configured === 2)">
                            <app-backup-config-request
                                    [drive]="drive.driveInfo"
                                    [restConfig]="restConfig"
                            ></app-backup-config-request></span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="pba_info">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>PBA
                    </th>
                    <td mat-cell *matCellDef="let drive" id="pba_info">{{drive.driveInfo.pba_display}}</td>
                </ng-container>
                <ng-container matColumnDef="keep_alive">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{'ssd.disk_config.keep_alive' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="keep_alive">
                      {{drive.driveInfo.keep_alive_display}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="command_logging">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{'ssd.disk_config.command_logging' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="command_logging">
                      {{drive.driveInfo.command_logging_display}}
                    </td>
                </ng-container>

                <ng-container *ngIf="showRansomware" matColumnDef="ransomware_detection">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ssd.details.ransomware' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="ransomware_detection">
                        {{drive.driveInfo.ransomware_detection_display}}</td>
                </ng-container>

                <ng-container *ngIf="showRansomware" matColumnDef="ransomware_sensitivity">
                    <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'ssd.details.ransomware-sensitivity' | translate}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="ransomware_sensitivity">
                        {{drive.driveInfo.ransomware_sensitivity_display}}</td>
                </ng-container>

                <ng-container matColumnDef="type">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fDrivesType}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="type">{{drive.driveInfo.typeDisplay}}</td>
                </ng-container>

                <ng-container matColumnDef="lastConnectedTo">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fLastConnected}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="lastConnectedTo">
                      <a [routerLink]="['/device', drive.driveInfo.license_uuid]">
                      {{drive.driveInfo.connected_to}}
                      </a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastSeen">
                    <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fLastSeen}}
                    </th>
                    <td mat-cell *matCellDef="let drive" id="lastSeen">{{drive.driveInfo.last_seen_display}}
                        <span *ngIf="!drive.driveInfo.connected"><sup>*</sup></span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
            </table>
        </div>
    </div>

</div>
